import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'dashboard',
      meta: {
        menu: '/'
      },
      component: resolve => require(['@/pages/dashboard'], resolve)
    }, {
      // 险种定义-列表
      path: '/insuranceDefine',
      name: 'insuranceDefine',
      meta: {
        menu: '/insuranceDefine',
        keep: true
      },
      component: resolve => require(['@/pages/insuranceDefine'], resolve)
    }, {
      // 险种定义-详情
      path: '/insuranceDefineDetails/:productId',
      name: 'insuranceDefineDetails',
      meta: {
        menu: '/insuranceDefine'
      },
      component: resolve => require(['@/pages/insuranceDefine/details'], resolve)
    }, {
      // 险种定义-新增
      path: '/addInsuranceDefine',
      name: 'addInsuranceDefine',
      meta: {
        menu: '/insuranceDefine'
      },
      component: resolve => require(['@/pages/insuranceDefine/details'], resolve)
    }, {
      // 供应商管理-列表
      path: '/supplierManage',
      name: 'supplierManage',
      meta: {
        menu: '/supplierManage',
        keep: true
      },
      component: resolve => require(['@/pages/supplierManage'], resolve)
    }, {
      // 供应商管理-详情
      path: '/supplierManageDetail',
      name: 'supplierManageDetail',
      meta: {
        menu: '/supplierManage'
      },
      component: resolve => require(['@/pages/supplierManage/details'], resolve)
    }, {
      // 供应商管理-新增
      path: '/addSupplierManage',
      name: 'addSupplierManage',
      meta: {
        menu: '/supplierManage'
      },
      component: resolve => require(['@/pages/supplierManage/details'], resolve)
    }, {
      // 合约管理: 合约定义-列表
      path: '/contractDefine',
      name: 'contractDefine',
      meta: {
        menu: '/contractDefine',
        keep: true
      },
      component: resolve => require(['@/pages/contractDefine'], resolve)
    }, {
      // 合约管理: 合约定义-详情
      path: '/contractDefineDetail/:agreementId',
      name: 'contractDefineDetail',
      meta: {
        menu: '/contractDefine'
      },
      component: resolve => require(['@/pages/contractDefine/details'], resolve)
    }, {
      // 合约管理: 合约定义-编辑
      path: '/editContract/:step/:agreementId',
      name: 'editContract',
      meta: {
        menu: '/contractDefine'
      },
      component: resolve => require(['@/pages/contractDefine/stepInfo'], resolve)
    }, {
      // 合约管理: 合约定义-新增
      path: '/addContract/:step/:agreementId?',
      name: 'addContract',
      meta: {
        menu: '/contractDefine'
      },
      component: resolve => require(['@/pages/contractDefine/stepInfo'], resolve)
    }, {
      // 合约管理: 合约复核-列表
      path: '/contractReview',
      name: 'contractReview',
      meta: {
        menu: '/contractReview',
        keep: true
      },
      component: resolve => require(['@/pages/contractReview'], resolve)
    }, {
      // 合约管理: 合约复核-详情
      path: '/contractReviewDetail/:agreementId',
      name: 'contractReviewDetail',
      meta: {
        menu: '/contractReview'
      },
      component: resolve => require(['@/pages/contractReview/details'], resolve)
    }, {
      // 合约管理: 合约审核-列表
      path: '/contractAudit',
      name: 'contractAudit',
      meta: {
        menu: '/contractAudit',
        keep: true
      },
      component: resolve => require(['@/pages/contractAudit'], resolve)
    }, {
      // 合约管理: 合约审核-详情
      path: '/contractAuditDetail/:agreementId',
      name: 'contractAuditDetail',
      meta: {
        menu: '/contractAudit'
      },
      component: resolve => require(['@/pages/contractAudit/details'], resolve)
    }, {
      // 合约管理: 合约奖金配置-列表
      path: '/contractBonusConfig',
      name: 'contractBonusConfig',
      meta: {
        menu: '/contractBonusConfig',
        keep: true
      },
      component: resolve => require(['@/pages/contractBonusConfig'], resolve)
    }, {
      // 合约管理: 合约奖金配置-详情
      path: '/contractBonusConfigDetail/:rateProjectId',
      name: 'contractBonusConfigDetail',
      meta: {
        menu: '/contractBonusConfig'
      },
      component: resolve => require(['@/pages/contractBonusConfig/details'], resolve)
    }, {
      // 合约管理: 合约奖金配置-新增
      path: '/addContractBonusConfig',
      name: 'addContractBonusConfig',
      meta: {
        menu: '/addContractBonusConfig'
      },
      component: resolve => require(['@/pages/contractBonusConfig/details'], resolve)
    }, {
      // 合约管理: 合约奖金关联-列表
      path: '/contractBonusRelate',
      name: 'contractBonusRelate',
      meta: {
        menu: '/contractBonusRelate',
        keep: true
      },
      component: resolve => require(['@/pages/contractBonusRelate'], resolve)
    }, {
      // 合约管理: 合约奖金关联-详情
      path: '/contractBonusRelateDetail/:agreementId',
      name: 'contractBonusRelateDetail',
      meta: {
        menu: '/contractBonusRelate'
      },
      component: resolve => require(['@/pages/contractBonusRelate/details'], resolve)
    }, {
      // 合约管理: 合约奖金关联-新增
      path: '/addContractBonusRelate',
      name: 'addContractBonusRelate',
      meta: {
        menu: '/contractBonusRelate'
      },
      component: resolve => require(['@/pages/contractBonusRelate/details'], resolve)
    }, {
      // 合约管理: 合约查询-列表
      path: '/contractQuery',
      name: 'contractQuery',
      meta: {
        menu: '/contractQuery',
        keep: true
      },
      component: resolve => require(['@/pages/contractQuery'], resolve)
    }, {
      // 合约管理: 合约查询-详情
      path: '/contractQueryDetail/:agreementId',
      name: 'contractQueryDetail',
      meta: {
        menu: '/contractQuery'
      },
      component: resolve => require(['@/pages/contractQuery/details'], resolve)
    }, {
      // 费率管理: 费率定义-列表
      path: '/rateDefine',
      name: 'rateDefine',
      meta: {
        menu: '/rateDefine',
        keep: true
      },
      component: resolve => require(['@/pages/rateDefine'], resolve)
    }, {
      // 费率管理: 费率定义-详情
      path: '/rateDefineDetail/:rateProcessId',
      name: 'rateDefineDetail',
      meta: {
        menu: '/rateDefine'
      },
      component: resolve => require(['@/pages/rateDefine/details'], resolve)
    }, {
      // 费率管理: 费率定义-编辑
      path: '/editRate/:step/:rateProcessId',
      name: 'editRate',
      meta: {
        menu: '/rateDefine'
      },
      component: resolve => require(['@/pages/rateDefine/stepInfo'], resolve)
    }, {
      // 费率管理: 费率定义-新增
      path: '/addRate/:step/:rateProcessId?',
      name: 'addRate',
      meta: {
        menu: '/rateDefine'
      },
      component: resolve => require(['@/pages/rateDefine/stepInfo'], resolve)
    }, {
      // 费率管理: 费率审核-列表
      path: '/rateAudit',
      name: 'rateAudit',
      meta: {
        menu: '/rateAudit',
        keep: true
      },
      component: resolve => require(['@/pages/rateAudit'], resolve)
    }, {
      // 费率管理: 费率审核-详情
      path: '/rateAuditDetail/:rateProcessId',
      name: 'rateAuditDetail',
      meta: {
        menu: '/rateAudit'
      },
      component: resolve => require(['@/pages/rateAudit/details'], resolve)
    }, {
      // 险种查询-列表
      path: '/insuranceQuery',
      name: 'insuranceQuery',
      meta: {
        menu: '/insuranceQuery',
        keep: true
      },
      component: resolve => require(['@/pages/insuranceQuery'], resolve)
    }, {
      // 险种查询-详情
      path: '/insuranceQueryDetail/:productId',
      name: 'insuranceQueryDetail',
      meta: {
        menu: '/insuranceQuery'
      },
      component: resolve => require(['@/pages/insuranceQuery/details'], resolve)
    },
    {
      // 活动发布-列表
      path: '/activityPublish',
      name: 'activityPublish',
      meta: {
        menu: '/activityPublish',
        keep: true
      },
      component: resolve => require(['@/pages/activityPublish'], resolve)
    }, {
      // 活动发布-新增
      path: '/activityPublishAdd',
      name: 'activityPublishAdd',
      meta: {
        menu: '/activityPublish'
      },
      component: resolve => require(['@/pages/activityPublish/add'], resolve)
    }, {
      // 活动发布-详情
      path: '/activityPublishDetail/:activityId',
      name: 'activityPublishDetail',
      meta: {
        menu: '/activityPublish'
      },
      component: resolve => require(['@/pages/activityPublish/detail'], resolve)
    },
    {
      // 活动审核-列表
      path: '/activityAudit',
      name: 'activityAudit',
      meta: {
        menu: '/activityAudit',
        keep: true
      },
      component: resolve => require(['@/pages/activityAudit'], resolve)
    }, {
      // 活动审核-详情
      path: '/activityAuditDetail/:activityId',
      name: 'activityAuditDetail',
      meta: {
        menu: '/activityAudit'
      },
      component: resolve => require(['@/pages/activityAudit/detail'], resolve)
    },
    {
      // 活动查询-列表
      path: '/activityQuery',
      name: 'activityQuery',
      meta: {
        menu: '/activityQuery',
        keep: true
      },
      component: resolve => require(['@/pages/activityQuery'], resolve)
    }, {
      // 活动查询-详情
      path: '/activityQueryDetail/:activityId',
      name: 'activityQueryDetail',
      meta: {
        menu: '/activityQuery'
      },
      component: resolve => require(['@/pages/activityQuery/detail'], resolve)
    }
  ]
})

// 解决懒加载导致的找不到js的偶现问题
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  const targetPath = router.history.pending.fullPath
  if (isChunkLoadFailed) {
    router.replace(targetPath)
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js